// The message public/push-sw.js sends an open tab on a notification tap.
export const NAVIGATE_MESSAGE = 'lupa:navigate'

/** The in-site path of a push's address; anything off the site is not followed. */
export function inAppPath(url: unknown, origin: string): string | null {
  if (typeof url !== 'string' || !url) return null
  try {
    const parsed = new URL(url, origin)
    if (parsed.origin !== origin) return null
    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return null
  }
}
